<div>
  Da li ste sigurni da želite da automatski izgenerišete kategorije? Ako ste već
  ručno unosili kategorije, promene će biti pregažene
</div>
